import Class from '@/Class';
import ComponentManager from '@/Management/ComponentManager';

export default class AffixWrapper extends Class {
    /**
     * Gibt den Prefix umhüllt mit Klammern und mit nachfolgendem Leerzeichen zurück.
     * Kann überschrieben werden, um bspw. andere Klammern oder gar keine Umhüllung zu erhalten.
     * @param value Der Prefix-Wert, der umhüllt werden soll
     */
    public static wrapPrefix(value: string): string {
        return value ? `(${value}) ` : value;
    }

    /**
     * Gibt den Postfix mit führendem Leerzeichen und umhüllt mit Klammern zurück.
     * Kann überschrieben werden, um bspw. andere Klammern oder gar keine Umhüllung zu erhalten.
     * @param value Der Postfix-Wert, der umhüllt werden soll
     */
    public static wrapPostfix(value: string): string {
        return value ? ` (${value})` : value;
    }
}

ComponentManager.setUtility('AffixWrapper', AffixWrapper, 'RADPresentation.HTMLClient.DefaultViewExtensions');